import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c49d35e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c49d35e')) {
      api.createRecord('3c49d35e', component.options)
    } else {
      api.reload('3c49d35e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c49d35e", function () {
      api.rerender('3c49d35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/delveryDialog/index.vue"
export default component.exports